import { Injectable } from "@angular/core";
import { fromEvent, Observable } from "rxjs";
import { distinctUntilChanged, map, startWith } from "rxjs/operators";


interface WindowSize {
	height: number,
	width: number
}

interface Breakpoint {
	min?: number,
	max?: number
};

interface BreakpointConfig {
    [name: string]: Breakpoint;
}

const breakpointConfig: BreakpointConfig = {
	xs: { max: 576 },
	sm: { min: 576, max: 768 },
	md: { min: 768, max: 992 },
	lg: { min: 992, max: 1200 },
	xl: { min: 1200, max: 1400 },
	xxl: { min: 1400, max: 1600 },
	xxxl: { min: 1600 }
};

export interface BreakpointSelected {
	name: string,
	breakpoint: Breakpoint,
	size: WindowSize
};


@Injectable()
export class BreakpointService {

	private selected$: Observable<BreakpointSelected>;
	private breakpointNames: string[];

	constructor() {
		this.breakpointNames = Object.keys( breakpointConfig );

		this.selected$ = fromEvent( window, 'resize' ).pipe(
			startWith( this.getBreakpointSelected() ),
			map( () => this.getBreakpointSelected() ),
			distinctUntilChanged( ( b1: BreakpointSelected, b2: BreakpointSelected) => b1.name == b2.name )
		);
	}

	public selected(): Observable<BreakpointSelected> {
		return this.selected$;
	}

	private getBreakpointSelected(): BreakpointSelected {
		let selected: BreakpointSelected;
		let height: number = window.innerHeight;
		let width: number = window.innerWidth;

		let namesFound: string[] = this.breakpointNames.filter( name => {
			let min: number = breakpointConfig[ name ].min? breakpointConfig[ name ].min: 0;
			let max: number = breakpointConfig[ name ].max? breakpointConfig[ name ].max: Number.MAX_VALUE;
			return width >= min && width < max;
		});

		if( namesFound.length > 0 ) {
			let name: string = namesFound[0];
			let breakpoint: Breakpoint = breakpointConfig[ name ];
			let size: WindowSize = { height, width };
			selected = { name, breakpoint, size };
		}

		return selected;
	}

}